const downloadCSV = (data, filename = "user_credentials.csv") => {
  const escapeCSVValue = (value) => {
    const raw = String(value ?? "");
    const stringValue = /^[=+\-@]/.test(raw) ? `'${raw}` : raw;
    if (
      stringValue.includes(",") ||
      stringValue.includes('"') ||
      stringValue.includes("\n")
    ) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    throw new Error("downloadCSV: expected a plain object");
  }
  const keys = Object.keys(data);
  const values = Object.values(data);

  const csvContent =
    keys.map(escapeCSVValue).join(",") +
    "\n" +
    values.map(escapeCSVValue).join(",");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export default downloadCSV;
